import { Admin, ChargeDispute, Contractor, Invite, InviteCode, Model, ModelName, Feed, PaymentDestination, Prescription, Transaction, WithdrawalRequest } from '../models';
import ApiBase, {Methods} from './api-base';


export interface MedAppResponse<T> {
    status: boolean;
    message: string;
    data: T;
  }

  export interface PagenatedRequest {
    modelName: ModelName;
    returnType: string;
    crieteria?: any;
    limit?: number;
    page?: number;
  }

  export interface ViewRequest {
    modelName: ModelName;
    modelId: number;
    populate?: string
  }

  export interface CreateRequest {
    modelName: ModelName;
    payload: any;
  }

  export interface UpdateRequest<T> {
    modelName: ModelName;
    where: Partial<T> & Record<string, any>;
    update: Partial<T> & Record<string, any>;
  }



  export interface PagenatedResponse<T>
  {payload: T[]; rows: number; page: number; total: number}
export class MedAppApi extends ApiBase {
    private static _instance: MedAppApi;


    public me = this.createGenericFetch<
    MedAppResponse<{user: Admin}>, never
    >("/admin/api/me", Methods.GET);

    public lgas = this.createGenericFetch<
    MedAppResponse<{lgas: string[]}>, never
    >("/admin/api/get-lgas", Methods.GET);

    public login = this.createGenericFetch<
    MedAppResponse<{user: Admin; token: string}>,
    {
        email: string;
        password: string;
      }
    >("/admin/api/login", Methods.POST);

    public signup = this.createGenericFetch<
    MedAppResponse<{user: Admin; token: string}>,
    {
        email: string;
        password: string;
        name: string;
        inviteToken: string;
      }
    >("/admin/api/register", Methods.POST);

    public changeDetails = this.createGenericFetch<
    MedAppResponse<{user: Admin; token: string}>,
    {
        Email: string; Name: string;
      }
    >("/admin/api/update-admin", Methods.POST);

    public changePassword = this.createGenericFetch<
    MedAppResponse<{user: Admin; token: string}>,
    {
        old: string; current: string
      }
    >("/admin/api/update-admin-password", Methods.POST);


    public dashboard = this.createGenericFetch<MedAppResponse<
      {
        Scheduled: number;
        Cancelled: number;
        Pending: number;
        Completed: number;
      }>, any>('/admin/api/view-dashboard', Methods.GET);

   public getModelList<T extends Model>(
req: PagenatedRequest
    ) {

      const {
        modelName,
        returnType,
        crieteria,
        limit = 50,
        page = 1
      } = req;
      const params =   {
        returnType,
        page,
        limit,
        crieteria: encodeURIComponent(JSON.stringify(crieteria || {})),
      }
      return this.createGenericFetch<
      MedAppResponse<{payload: Array<T>; rows: number; page: number; total: number}>,
      any
      >(`/admin/api/model`, Methods.GET)(params, {}, {}, [modelName]);
    }

    public deleteModels(req: {
      modelName: ModelName;
      ids: Array<{ id: number }>;
      deleteForever?: boolean;
    }) {
       const {
        modelName,
        ids,
        deleteForever = false
      } = req;
      return this.createGenericFetch<MedAppResponse<{success: boolean;}>, {ids: Array<{ id: number }>}>(deleteForever ? "/admin/api/delete-forever" : "/admin/api/delete", Methods.POST)({}, {}, {ids}, [modelName]);

    }

    public updateModel<T extends Model>(req: UpdateRequest<T>){
        const {modelName,
          where = {},
          update = {}
        } = req;
        
      return this.createGenericFetch<MedAppResponse<{
        success: boolean;
        model: T;
      }>, {where: any; update: any;}>('/admin/api/update', Methods.POST)({}, {}, {where, update}, [modelName]);
    }

    public viewModel<T extends Model>(req: ViewRequest){
      const {modelName,
        modelId,
        populate,
      } = req;
      
    return this.createGenericFetch<MedAppResponse<{
      success: boolean;
      payload?: T;
    }>,any>('/admin/api/view', Methods.GET)({populate}, {}, {}, [modelName, modelId + '']);
  }


  public createModel<T extends Model>(req: CreateRequest){
    const {modelName,
      payload
    } = req;
    
  return this.createGenericFetch<MedAppResponse<{
    success: boolean;
    payload?: T;
  }>,any>('/admin/api/create-model', Methods.POST)({}, {}, {payload}, [modelName]);
}

public getUserFromId<T extends Model>(req: ViewRequest){
  const {modelName,
    modelId,
  } = req;
  
return this.createGenericFetch<MedAppResponse<{
  success: boolean;
  payload?: T;
}>,any>('/admin/api/get-user-by-id', Methods.GET)({}, {}, {}, [modelName, modelId + '']);
}

public contractorLogin =
 this.createGenericFetch<{user: Contractor; token: string, refresh: string; expires: string;},
 {
  Email: string;
  Password: string;
  Role: string;
  source: string;
}
    >("/api/v1/users/login", Methods.POST);

public getDashboard = this.createGenericFetch<
{  Delivered: number;
  Rejected: number;
  Pending: number;
  Accepted: number;
},
any
>('/api/v1/contractors/get-dashboard', Methods.GET);


public meContractor = this.createGenericFetch<
MedAppResponse<{user: Contractor}>, never
>("/api/v1/contractors/get-me", Methods.GET);

public getInvites(
  req: Pick<PagenatedRequest, 'crieteria' | 'limit' | 'page'>
      ) {
  
        const {
          crieteria,
          limit = 50,
          page = 1
        } = req;
        const params =   {
          page,
          limit,
          crieteria: encodeURIComponent(JSON.stringify(crieteria || {})),
        }
        return this.createGenericFetch<
        MedAppResponse<PagenatedResponse<Invite>>,
        any
        >(`/api/v1/contractors/invites-web`, Methods.GET)(params, {}, {});
      }


  public requestResetPassword = this.createGenericFetch<
  MedAppResponse<{done: boolean;}>, {Email: string;}
  >('/api/v1/users/request-reset-password', Methods.POST);

  public verifyOtp = this.createGenericFetch<
  MedAppResponse<{done: boolean;}>, {
    Email: string;
    token: string;
    password: string;
  }>('/api/v1/users/reset-password?modelName=contractor', Methods.POST);

  
  public getPrescriptions(
        req: Pick<PagenatedRequest, 'crieteria' | 'limit' | 'page'>
            ) {
        
              const {
                crieteria,
                limit = 50,
                page = 1
              } = req;
              const params =   {
                page,
                limit,
                crieteria: encodeURIComponent(JSON.stringify(crieteria || {})),
              }
              return this.createGenericFetch<
              MedAppResponse<PagenatedResponse<Prescription>>,
              any
              >(`/api/v1/contractors/prescriptions-web`, Methods.GET)(params, {}, {});
            }
      

  public getInvite = this.createGenericFetch<MedAppResponse<Invite>, any>('/api/v1/contractors/view-invite', Methods.GET)
  public getPrescription = this.createGenericFetch<MedAppResponse<Prescription>, any>('/api/v1/contractors/view-prescription', Methods.GET)

  public appraiseInvite = this.createGenericFetch<MedAppResponse<{updated: boolean}>, {id: number; ContractorExtraInfo: string; Amount: number;}>
  ('/api/v1/contractors/appraise/invite', Methods.POST)

  public appraisePrescription = this.createGenericFetch<MedAppResponse<{updated: boolean}>, Partial<Prescription>>
  ('/api/v1/contractors/appraise/prescription', Methods.POST);
  
  public uploadFiles(
    id: number,
    dir: string
  ) {
    return this.createGenericUpload<MedAppResponse<{uploaded: boolean;}>>(`/api/v1/contractor/upload-results/${id}?directory=${dir}`)
  }

  public cancelInvitePres(variant: string, id: number) {
    return this.createGenericFetch<MedAppResponse<{cancelled: boolean}>, never>(`/api/v1/contractors/cancel/${variant}/${id}`, Methods.GET);
  }

  public getMembersCount =
 this.createGenericFetch<MedAppResponse<{members: number}>, never>("/admin/api/organization/member-count", Methods.GET);
 public inviteMember =
 this.createGenericFetch<MedAppResponse<{invite: InviteCode}>, {email: string; sendEmail: boolean; memberType: "owner" | "member" | "manager";}>("/admin/api/organization/invite-member", Methods.POST);

  public contractorUpdateDetails = this.createGenericFetch<MedAppResponse<Contractor>, Partial<Contractor>>('/api/v1/contractors/update-details', Methods.POST);
  public logout = this.createGenericFetch<{done: boolean}, {deviceUid?: string}>('/api/v1/users/logout', Methods.POST);

  public approveWithdrawal = this.createGenericFetch<MedAppResponse<{
    transaction: Transaction;
    request: WithdrawalRequest;
    paymentDestination: PaymentDestination;

  }>, {withdrawalRequest: number}>('/admin/api/transactions/initialize-withdrawal', Methods.POST);

  public resolveChargeDispute= this.createGenericFetch<MedAppResponse<{
    transaction: Transaction;
    dispute: ChargeDispute;
    paymentDestination: PaymentDestination;

  }>, {chargedispute: number, action: 'refund' | 'resolve', comment: string}>('/admin/api/transactions/resolve-dispute', Methods.POST);

  public createFeed = this.createGenericFetch<MedAppResponse<{
    success: boolean;
    payload?: Feed;
  }>, FormData>('/admin/api/create-feed', Methods.POST);
  public static get Instance(): MedAppApi {
        return (
          this._instance ||
          (this._instance = new MedAppApi(
            process.env.REACT_APP_HOST || 'https://api.letstalkmd.net',
          //   'http://localhost:1337'
          ))
        );
    }
    public resetAppState() {
        this.setToken('');
    }
}


export default MedAppApi.Instance;
